import React from "react";
import { REFUND_DAYS } from "../../config/subscription.js";
import "./duvidas.css";

function Duvidas() {
    const faqData = [
        {
            question: "A quem se destinam os cursos do site?",
            answer: `
                Todo o conteúdo do site foi pensado para alunos de cursos de engenharia, que costumam ter disciplinas de circuitos elétricos.
                No entanto, todos que quiserem aprender circuitos neste nível são bem vindos, desde que saibam do direcionamento.
            `
        },
        {
            question: "Quanto de matemática é necessário saber para fazer os cursos?",
            answer: `
                É recomendado ter uma base boa de matemática de ensino fundamental e médio, em especial saber fazer contas básicas, geometria
                básica, resolver equações simples, sistemas de equações lineares e números complexos. Noções de cálculo diferencial e integral
                são úteis em alguns módulos mais avançados, mas se você não souber, consegue aprender a maior parte do curso.
            `
        },
        {
            question: "O que o Domínio Elétrico não ensina?",
            answer: `
                Nenhum curso do site ensina a reparar aparelhos elétricos ou eletrônicos. Por isso dizemos que os conteúdos são voltados para 
                o contexto de cursos de engenharia.
            `
        },
        {
            question: "O Domínio Elétrico fornece certificado de conclusão?",
            answer: `
                Sim, mas depende de concluir as aulas e passar numa prova (que não é fácil). De centenas de alunos, pouquíssimos conseguiram certificado até hoje.
                Valorizamos a seriedade do nosso ensino. Aqui não é estilo "pagou-passou". Se estiver em busca de um certificado fácil, o Domínio Elétrico não vale a pena.
                Mas se quiser dominar os circuitos, aqui é o lugar certo.
            `
        },
        {
            question: "A partir de qual semestre da faculdade vale a pena fazer o curso?",
            answer: `
                Um aluno com boa formação escolar consegue aproveitar a maior parte do curso mesmo que comece já no primeiro semestre do curso.
                Apenas alguns módulos mais avançados (Circuitos de Primeira Ordem, Circuitos de Segunda Ordem, Análise Avançada de Circuitos) 
                requerem conceitos básicos de derivadas e integral e EDOs (equações diferenciais ordinárias) lineares mais simples.
            `
        },
        {
            question: "Por onde começar o curso?",
            answer: `
                A não ser que já tenha noção de circuitos elétricos, recomendo que siga a ordem natural do curso, começando do módulo de Conceitos
                Básicos do Domínio Elétrico (conteúdo principal).
            `
        },
        {
            question: "Qual o perfil dos alunos do Domínio Elétrico?",
            answer: `
                Temos alunos de quase todos os estados do Brasil e alguns de fora do Brasil também. São alunos tanto de escolas técnicas, faculdades públicas
                e privadas. Temos alunos que estão na graduação e temos alunos já formados, trabalhando no mercado de trabalho ou no meio acadêmico.
                Sendo assim, temos um público bem variado e é bem possível que tenhamos alunos como você.
            `
        },
        {
            question: "E se eu não gostar dos cursos?",
            answer: `
                Se você entendeu do que se trata e é o que você quer aprender, acreditamos que vai gostar. Mas ainda assim, para caso não goste,
                temos uma garantia de ${REFUND_DAYS} dias, em que você pode pedir reembolso total e cancelamento da assinatura durante este prazo.
            `
        },
        {
            question: "As faculdades já não ensinam circuitos elétricos?",
            answer: `
                Em tese sim, e em um cenário ideal, você não precisaria do Domínio Elétrico ou de qualquer outro conteúdo além da sua faculdade
                para aprender circuitos elétricos. Mas a realidade que temos no Brasil não é esta. Os anos de aulas online na pandemia deixaram 
                isso bem claro. Por isso alunos de diversos contextos vêm para o Domínio Elétrico aprender conosco.
            `
        },
        {
            question: "As aulas são teóricas ou práticas?",
            answer: `
                Temos tanto aulas teóricas quanto aulas práticas. As aulas teóricas expõem os conceitos básicos, enquanto as aulas práticas (no DE Labs) 
                mostram algum experimento em laboratório. Ambas são importantes. Em toda a ciência, a teoria veio como forma de explicar o que
                é observado na natureza (ou seja, na prática), por mais que não consiga explicar perfeitamente tudo. Depois, com experiências 
                práticas você consegue visualizar tudo o que foi aprendido com conceitos, números e equações.
            `
        },
        {
            question: "Em quanto tempo eu consigo fazer o curso?",
            answer: `
                Fazendo em um ritmo tranquilo mas com disciplina, é possível concluir todo o conteúdo principal do Domínio Elétrico em 1 ano.
                Se tiver com mais tempo e mais dedicação, é possível fazer em 6 meses ou até menos.
            `
        },
        {
            question: "O curso me ajuda a conseguir uma vaga no mercado de trabalho?",
            answer: `
                Sim, mas não de forma tão direta. O curso ajuda a aprender circuitos elétricos, que é importante para passar nas
                disciplinas de circuitos elétricos, que por sua vez são necessárias para se formar em um curso superior como engenharia elétrica.
                Portanto, indiretamente sim, o curso ajuda a conseguir emprego, porque ajuda você a se formar na faculdade, que faz toda
                a diferença para conseguir um emprego. Além disso, se a sua formação na faculdade foi precária, aqui no Domínio Elétrico você 
                pode compensar para não passar vergonha no ambiente profissional.
            `
        }
    ];

    return (
        <section className="duvidas-section">
            <div className="duvidas-container">
                
                <div className="duvidas-header">
                    <h2>Perguntas Frequentes</h2>
                    <p>
                        Aqui estão as dúvidas mais comuns sobre cursos, certificados, conteúdo e funcionamento do site Domínio Elétrico.
                    </p>
                </div>

                <div className="duvidas-grid">
                    {faqData.map((item, index) => (
                        <div key={index} className="duvida-card">
                            <h2>{item.question}</h2>
                            <p>{item.answer}</p>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
}

export default Duvidas;